import React from "react";
import { Link } from "react-router-dom";

const NotFound = ({ handlelogout }) => {
  return (
    <div className="not-found">
      <h1 className="text-center no-head">
        <span className="first4">4</span>
        <span className="middle0">0</span>
        <span className="last4">4</span>
      </h1>
      <h3 className="text-center no-para">Sorry Page Not Found!</h3>
      <div className="text-center">
        <Link to="/" className="back-to-home">
          <i className="fa fa-long-arrow-left"></i> Back To Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
